import { combineReducers } from "redux";
import { reportScheduledState } from "./reportSchedulesReducer";

export const reportSchedulesReducers = combineReducers({
    reportScheduledState: reportScheduledState
});
